// Straight-line (haversine) distance, used only to bucket an exact Places
// address back to the nearest configured City for route/price matching -
// the actual billed distance still comes from getDrivingDistance.
export function haversineDistanceKm(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export function findNearestCity<
  T extends { latitude: number; longitude: number }
>(cities: T[], lat: number, lng: number): T | null {
  if (cities.length === 0) return null;

  let nearest = cities[0];
  let minDistance = haversineDistanceKm(
    lat,
    lng,
    nearest.latitude,
    nearest.longitude
  );

  for (const city of cities.slice(1)) {
    const distance = haversineDistanceKm(lat, lng, city.latitude, city.longitude);
    if (distance < minDistance) {
      minDistance = distance;
      nearest = city;
    }
  }

  return nearest;
}
